var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.availableServices.length < 1)?_c('div',[_vm._v("\n  Loading 6xx services\n")]):_c('v-chip',{attrs:{"color":_vm.color},on:{"click":_vm.handleClick}},[_vm._v("6XX\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116115fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/Filter6xx.vue
// module id = null
// module chunks = 